export const getSelectedCoursewareItems = (state) => state.getIn(['selectionState', 'coursewareItems']).toJS();
export const getClipboard = (state) => state.getIn(['selectionState', 'clipboard']).toJS();
